module.exports = __webpack_public_path__ + "fonts/OpenSans-Regular.795f58b4.woff";